<style lang="stylus">
.agreementcard
    margin-top 27px
    padding: 34px 0 84px
    color: #717171
    .title
        font-size: 20px
        border-bottom: 2px solid $basecolor
        line-height: 70px
        text-align: center
    .content
        white-space: pre-wrap
        font-size: 14px
</style>

<template>
    <Card :bordered="false" class="agreementcard appwrap" dis-hover>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </Card>
</template>

<script>
export default {
    name: 'agreement'
}
</script>



// WEBPACK FOOTER //
// src/components/agreement/agreement.vue